import React from 'react'
import { ButtonContent } from './CONTENT'
import { CustomButton } from './CustomRulesStyled'

export default function BetButtons() {
  return (
    <>
      {ButtonContent.map((item, id) => (
        <CustomButton
          key={id}
          background={item.background}
          color={item.color}
          className={item.class}
          data-testid={item.class}
        >
          <div className='bet-button'>
            {item.icon}
            <span>{item.name}</span>
          </div>
          <p>
            {<b>{item.title}</b>} – {item.description}
          </p>
        </CustomButton>
      ))}
    </>
  )
}
